import AvailableTimeRequest from "@/model/requests/AvailableTimeRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import BookingServices from "@/services/BookingServices";
import AvailableTimeServices from "@/services/AvailableTimeServices";
const availableTimeService = new AvailableTimeServices();

export const namespaced = true;

export const state = {
  availableTime: {},
  clickedDate: "",
  notifications: [],
  dateEvents: [
    {
      start: "2022-09-12T12:00:00",
      end: "2022-09-12T13:00:00",
      title: "",
      allDay: false
    }
  ],
  event: {},
  availableGroups: [],
  sessionsCount: [],
  timeValue: "",
  availableTimes: [],
  availableDates: [],
  dailyTimeGroups: [],
  selectedDate: "",
  timeSlots: [],
  selectedDateFromModal: "",
  availableDays: {},
  selectedTimeSlots: [],
  selectedTimeGroup: {},
  availabilitySuccess: false,
  subscriptionDays: [],
  selectedSlot: {},
  selectedSubSlot: {},
  subSlots: [],
  mergedDays: ""
};

export const getters = {
  getAvailableTime: state => {
    return state.availableTime;
  },
  getClickedDate: state => {
    return state.clickedDate;
  },
  getDateEvents: state => {
    return state.dateEvents;
  },
  getEvent: state => {
    return state.event;
  },
  getAvailableGroups: state => {
    return state.availableGroups;
  },
  getSessionsCount: state => {
    return state.sessionsCount;
  },
  getTimeValue: state => {
    return state.timeValue;
  },
  getAvailableTimes: state => {
    return state.availableTimes;
  },
  getAvailableDates: state => {
    return state.availableDates;
  },
  getAvailableDays: state => {
    return state.availableDays;
  }
};

export const mutations = {
  setAvailableTime: (state, payload) => {
    state.availableTime = payload;
  },
  setClickedDate: (state, payload) => {
    state.clickedDate = payload;
  },
  setDateEvents: (state, payload) => {
    state.dateEvents = payload;
  },
  setEvent: (state, payload) => {
    state.event = payload;
  },
  setAvailableGroups: (state, payload) => {
    state.availableGroups = payload;
  },
  setSessionsCount: (state, payload) => {
    state.sessionsCount = payload;
  },
  setTimeValue: (state, payload) => {
    state.timeValue = payload;
  },
  setAvailableTimes: (state, payload) => {
    state.availableTimes = payload;
  },
  setAvailableDates: (state, payload) => {
    state.availableDates = payload;
  },
  setDailyTimeGroups: (state, payload) => {
    state.dailyTimeGroups = payload;
  },
  setSelectedDate: (state, payload) => {
    state.selectedDate = payload;
  },
  setTimeSlots: (state, payload) => {
    state.timeSlots = payload;
  },
  setSelectedDateFromModal: (state, payload) => {
    state.selectedDateFromModal = payload;
  },
  setAvailableDays: (state, payload) => {
    state.availableDays = payload;
  },
  setSelectedTimeSlots: (state, payload) => {
    state.selectedTimeSlots = payload;
  },
  setSelectedTimeGroup: (state, payload) => {
    state.selectedTimeGroup = payload;
  },
  setAvailabilitySuccess: (state, payload) => {
    state.availabilitySuccess = payload;
  },
  setSubscriptionDays: (state, payload) => {
    state.subscriptionDays = payload;
  },
  setSelectedSlot: (state, payload) => {
    state.selectedSlot = payload;
  },
  setSubSlots: (state, payload) => {
    state.subSlots = payload;
  },
  setSelectedSubSlot: (state, payload) => {
    state.selectedSubSlot = payload;
  },
  setMergedDays: (state, payload) => {
    state.mergedDays = payload;
  }
};

export const actions = {
  // fetchEvents({ commit, state }, payload = AvailableTimeRequest.createEvent) {
  //   StoreUtils.commit("setEvent", payload);
  //   this.$store.state.availability.dateEvents.push(payload);
  // },
  createEvent({ commit }, payload = AvailableTimeRequest.createEvent) {
    StoreUtils.commit("setEvent", payload);
  },

  createAvailableTimeGroup(
    { commit },
    payload = AvailableTimeRequest.createAvailableTimeGroup
  ) {
    let successAction = () => {
      // console.log(StoreUtils.rootGetters(
      //     "professional/getCustomerToProfessionalId"
      // ))
      commit("setAvailabilitySuccess", true);
      // let professionalId;
      // if('professional' in StoreUtils.rootGetters("auth/getUserInfo")){
      //   professionalId = StoreUtils.rootGetters("auth/getUserInfo").professional.professionalId;
      // }
      // else{
      //   professionalId = StoreUtils.rootGetters(
      //     "professional/getCustomerToProfessionalId"
      //   );
      // }
      // return StoreUtils.dispatch("availability/readByProfessionalId", {
      //   professionalId
      // });
    };
    return availableTimeService.createAvailableTimeGroup(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  deleteAvailableTimeGroup({ commit }, payload = AvailableTimeRequest.delete) {
    let successAction = () => {
      commit("setAvailabilitySuccess", true);
      // let professionalId = StoreUtils.rootGetters("auth/getUserInfo")
      //   .professional.professionalId;
      // return StoreUtils.dispatch("availability/readByProfessionalId", {
      //   professionalId
      // });
    };
    return availableTimeService.deleteAvailableTimeGroup(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByProfessionalId(
    { commit },
    payload = AvailableTimeRequest.readByProfessionalId
  ) {
    let successAction = responseData => {
      commit("setAvailableGroups", responseData.data);
    };
    return availableTimeService.readByProfessionalId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readCount({ commit }, payload = AvailableTimeRequest.readCount) {
    let successAction = responseData => {
      commit("setSessionsCount", responseData.listData);
    };
    return availableTimeService.readCount(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readDates({ commit }, payload = AvailableTimeRequest.readDates) {
    let successAction = responseData => {
      commit("setAvailableDates", responseData.data);
    };
    return availableTimeService.readDates(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByDate({ commit }, payload = AvailableTimeRequest.readByDate) {
    let successAction = responseData => {
      commit("setDailyTimeGroups", responseData.listData);
    };
    return availableTimeService.readByDate(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByAvailableTimeGroupId(
    { commit },
    payload = AvailableTimeRequest.readByAvailableTimeGroupId
  ) {
    let successAction = responseData => {
      let modifiedData = responseData.data.map(item => ({
        ...item,
        state: false
      }));
      commit("setTimeSlots", modifiedData);
    };
    return availableTimeService.readByAvailableTimeGroupId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readNextDays({ commit }, payload = AvailableTimeRequest.readNextDays) {
    let successAction = responseData => {
      commit("setAvailableDays", responseData.data);
    };
    return availableTimeService.readNextDays(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readAvailableSubscriptionTime(
    { commit },
    payload = AvailableTimeRequest.readSubscriptionTime
  ) {
    let successAction = responseData => {
      commit("setSubSlots", responseData.listData);
    };
    return availableTimeService.readAvailableSubscriptionTime(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  multipleSelection({ state, commit }, slot, index) {
    let selectedList = [];

    let slots = [...state.timeSlots];

    // console.log("happy");
    // console.log(slots);
    // console.log(index);
    if (slot.state === false && selectedList.includes(slot) === false) {
      // console.log(slot.availableTimeId);
      // console.log("before");
      // console.log(slots);
      slots
        .filter(item => item.availableTimeId === slot.availableTimeId)
        .map(item => (item.state = true));
      // console.log("after");
      // console.log(slots);
      // slots[index].state = true;
      selectedList.push(slot);
      // console.log(selectedList);
      // commit("setTimeSlots", slots);
      commit("setSelectedTimeSlots", selectedList);
    } else {
      // slots[index].state = false;
      slots
        .filter(item => item.availableTimeId === slot.availableTimeId)
        .map(item => (item.state = false));
      selectedList = selectedList.filter(
        item => item.availableTimeId !== slot.availableTimeId
      );
      // console.log(selectedList);
      commit("setTimeSlots", slots);
      commit("setSelectedTimeSlots", selectedList);
    }
  }
};
